import * as Styled from '../styled';
import { IRemoteWorkspace } from '@/lib/workspaces/workspaceApi';
import { CheckIcon } from '@radix-ui/react-icons';
import { Row, Stack } from '@/ui/primatives';
import { WorkspaceUpdatedInfo } from '../CustomComponents';
import { LayersIcon } from '@radix-ui/react-icons';
import Tag from '@/ui/Tag';

const WorkspaceRow: React.FC<{
  workspaceOption: WorkspaceOption;
  onClick?: (workspace: IRemoteWorkspace) => void;
}> = ({ workspaceOption, onClick }) => {
  const { workspace, isSelected, label } = workspaceOption;
  const isWorkspaceOpen = !workspace.closing_commit;
  const isErrorState = workspace.commits_behind === null && isWorkspaceOpen;
  const disabled = isErrorState || !isWorkspaceOpen;

  if (disabled) {
    return null;
  }

  return (
    <Styled.ListItem disabled={disabled} onClick={() => onClick?.(workspace)}>
      <CheckIcon height="20" width="20" style={{ opacity: isSelected ? 1 : 0 }} />
      <Stack gap={5} className="list-item-content">
        <Row justifyContent="space-between" alignItems="center">
          <Row gap={5} alignItems="center">
            <LayersIcon height="12" width="12" />
            <div className="commitRef">{label}</div>
          </Row>
          {(!isWorkspaceOpen || isErrorState) && (
            <Tag variant="error" small pill>
              {isErrorState ? 'error' : 'closed'}
            </Tag>
          )}
        </Row>
        <WorkspaceUpdatedInfo workspace={workspace} />
      </Stack>
    </Styled.ListItem>
  );
};

type WorkspaceOption = {
  value: string;
  label: string;
  type: 'workspace';
  workspace: IRemoteWorkspace;
  isDisabled: boolean;
  isSelected: boolean;
};

const getWorkspaceOptionsList = (workspaces: IRemoteWorkspace[], selectedRef?: string): WorkspaceOption[] => {
  let options: WorkspaceOption[] = workspaces.map((workspace) => ({
    value: workspace.id,
    label: workspace.name || workspace.id.split('-')[0],
    type: 'workspace',
    workspace,
    isDisabled: false,
    isSelected: workspace.name === selectedRef || workspace.id === selectedRef,
  }));

  // const selectedWorkspace = selectedRef
  //   ? workspaces.find((workspace) => workspace.id === selectedRef || workspace.name === selectedRef)
  //   : undefined;

  // if the selected branch is not the same as the commit, add the commit to the options
  // if (!!selectedWorkspace) {
  //   options.push({
  //     value: selectedWorkspace.id,
  //     label: selectedWorkspace.name || selectedWorkspace.id,
  //     type: 'workspace',
  //     workspace: selectedWorkspace,
  //     isDisabled: false,
  //   } as WorkspaceOption);
  // }

  // sort by commit timestamp
  options.sort(
    (a, b) => new Date(b.workspace?.updated_at || '').getTime() - new Date(a.workspace?.updated_at || '').getTime(),
  );

  // sort selected branch to the top
  options.sort(function (x, y) {
    return x.value == selectedRef ? -1 : y.value == selectedRef ? 1 : 0;
  });
  return options;
};

const WorkspaceList: React.FC<{
  workspaces: IRemoteWorkspace[];
  selectedWorkspace?: string;
  onClick?: (workspace: IRemoteWorkspace) => void;
}> = ({ workspaces, selectedWorkspace, onClick }) => {
  const workspaceOptions = getWorkspaceOptionsList(workspaces, selectedWorkspace);
  return (
    <Styled.List>
      {workspaceOptions.map((option) => (
        <WorkspaceRow key={option.value} workspaceOption={option} onClick={onClick} />
        // <Styled.ListItem key={option.value} onClick={() => onClick?.(option.workspace)}>
        //   <CheckIcon height="20" width="20" style={{ opacity: option.isSelected ? 1 : 0 }} />
        //   <Stack gap={2} className="list-item-content">
        //     <Row gap={5} alignItems="center">
        //       <LayersIcon height="12" width="12" />
        //       <div className="commitRef">{option.label}</div>
        //     </Row>
        //     <WorkspaceUpdatedInfo workspace={option.workspace} />
        //   </Stack>
        // </Styled.ListItem>
      ))}
    </Styled.List>
  );
};

export default WorkspaceList;
